export interface AccessStep {
  text: string
  emphasis?: string
}

export const accessSteps: AccessStep[] = [
  {
    text: 'Click the green button below to open your Google Drive folder.',
  },
  {
    text: 'Download and save all 6 volumes and your 5 bonus systems to your computer, tablet, or mobile device.',
  },
  {
    emphasis: 'Important:',
    text: "Download your content now. As a backup, we'll also send you the same access by email later today. If you don't see it, be sure to check your Spam, Junk, Promotions, or Updates folder.",
  },
]

export const downloadUrl =
  'https://drive.google.com/drive/folders/1dd6OvZye8X5h5cIBkUpeUFqT__ed88Ev?usp=sharing'

export const supportEmail = 'soporte.recursopack@gmail.com'

export const productImage =
  'https://cdn.magicpatterns.com/uploads/9DXGAVP2zfKp5zEjaRpwPf/WhatsApp_Image_2026-08-24_at_7.44.26_PM.webp'
